import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {
  @Input() item;
  @Input() from;

  data: any = {}
  constructor() { }

  ngOnInit(): void {
    if (this.from == 'userCategory') {
      this.data = {
        icon: this.item.logo,
        image: this.item.cover
      }
    } else {
      this.data = this.item
    }
  }

}
